<template>
  <!-- 当前库存查询 -->
  <div>
    <!-- 搜索 -->
    <div class="handle_box">
      <el-input
        style="width: 300px; margin-right: 10px"
        prefix-icon="el-icon-edit"
        v-model="goodsName"
        size="mini"
        placeholder="请输入商品名称"
        clearable
      >
      </el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        size="mini"
        @click="onSearch"
        >搜索
      </el-button>
    </div>
    <!-- 表格 -->
    <div>
      <!-- 新增及删除 -->
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        height="calc(100vh - 276px)"
        @row-dblclick="updateRecordView"
      >
        <el-table-column type="index" label="编号" width="50"></el-table-column>
        <el-table-column prop="goodsCode" label="商品编码" align="center">
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" align="center">
        </el-table-column>
        <el-table-column
          prop="goodsModel"
          label="商品型号"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="goodsTypeDesc"
          label="商品类别"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="manufacturer"
          label="生产厂家"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="库存量"
          align="center"
          show-overflow-tooltip
        >
        <template slot-scope="scope">
          {{scope.row.inventoryMin}} ( {{scope.row.goodsUnitDesc}} )
        </template>
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="销售总数"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="上次进价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="成本均价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="销售价"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="inventoryMin"
          label="库存总额"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>

      <!-- <el-table-column align="center" prop="cz" label="操作" width="100px">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="light"
              content="编辑商品信息"
              placement="top"
            >
              <el-button
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-edit"
                @click="goRedact(scope, tableData)"
              ></el-button>
            </el-tooltip>

            <el-tooltip class="item" effect="light" content="删除该数据" placement="top">
              <el-button
                v-if="scope.row.goodsState == null || scope.row.goodsState == 0"
                style="float: none; padding: 3px 0; color: #ff0000"
                type="text"
                icon="el-icon-delete"
                @click="deleteRow(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column> -->
      </el-table>
      <div style="display: flex; justify-content: flex-end; margin-top: 5px">
        <el-pagination
          background
          @current-change="currentChange"
          @size-change="sizeChange"
          :page-sizes="[10, 20, 50, 100, 1000]"
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="total"
          :current-page="page">
        </el-pagination>
      </div>
    </div>
    <!-- 弹出框 -->
    </div>
</template>

<script>
import {
  dictionaries,
  postCitys,
  goodsList,
  addGoods,
  deleteGoods,
  querySupplier,
  updateGoods,
} from "../../../api/SlmsData/Merchandise";
export default {
  data() {
    // 在 Input 值改变时触发
    return {
      goodsName: "", //供应商名称
      dialogFormVisible: false,
      tableData: [],
      requestApi: true, //true新增,false修改
      ruleForm: {
        goodsName: "",
        goodsModel: "",
        goodsType: "",
        goodsUnit: "",
        inventoryMin: 0,
        manufacturer: "",
        remarks: "",
      },
      flag: true,
      categoryType: [],
      procedureType: [],
      titleType: "",
      total: 0,
      multipleSelection: [],
      page: 1, //页码
      limit: 10, //1页记录数

      rules: {
        goodsName: [{ required: true, message: "请填写供应商名称", trigger: "blur" }],
        goodsModel: [{ required: true, message: "请填写商品型号", trigger: "blur" }],
        goodsType: [{ required: true, message: "请选择商品类别", trigger: "change" }],
        goodsUnit: [{ required: true, message: "请选择商品单位", trigger: "change" }],
        inventoryMin: [
          {
            required: true,
            message: "请输入数量，且为正整数类型",
            trigger: "blur",
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
          },
        ],
        manufacturer: [{ required: true, message: "请填写生产厂家", trigger: "blur" }],
      },
    };
  },
  created() {
    this.searchType();
    this.searchButton();
  },
  mounted() {},
  methods: {
    //查询字典表
    async searchType() {
      let resA = await dictionaries("goods_type"); //货品类别
      this.categoryType = resA.result;
      let resB = await dictionaries("goods_unit"); //商品单位
      this.procedureType = resB.result;
    },
    //头部商品查询 dictionaries
    // 搜索/筛选入口：先回到第 1 页再查（避免在第 N 页搜索时结果不足一页而显示空白）
    onSearch() {
      this.page = 1;
      this.searchButton();
    },

    async searchButton() {
      let res = await goodsList(this.page, this.limit, this.goodsName);
      this.tableData = res.data;
      this.total = res.count;
    },
    //双击表格打开弹窗
    async updateRecordView(scope) {
      this.titleType = "查看商品信息";
      this.ruleForm = scope;
      this.dialogFormVisible = true;
      this.flag = false;
    },
    //提交新增商品信息
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          this.$notify({
            title: "操作失败",
            dangerouslyUseHTMLString: true,
            message: "请填写完整",
            type: "warning",
          });
          return;
        }
        let resData = {};
        try {
          if (this.requestApi) {
            resData = await addGoods(this.ruleForm);
            this.$refs["ruleForm"].resetFields();
          } else {
            // let {
            //   goodsName,
            //   goodsModel,
            //   goodsType,
            //   goodsUnit,
            //   inventoryMin,
            //   manufacturer,
            //   remarks,
            // } = this.ruleForm;
            // let res = {
            //   goodsName:goodsName,
            //   goodsModel: goodsModel,
            //   goodsType: goodsType,
            //   goodsUnit: goodsUnit,
            //   inventoryMin: inventoryMin,
            //   manufacturer: manufacturer,
            //   remarks: remarks,
            // };
            resData = await updateGoods(this.ruleForm);
          }
        } catch (e) {
          console.error("接口异常");
        }
        this.searchButton();
        this.$notify({
          title: resData ? "成功" : "失败",
          dangerouslyUseHTMLString: true,
          message: resData ? resData.message : "服务器开小差了，请稍后再试",
          type: resData ? "success" : "warning",
        });
      });
    },
    //关闭弹窗前回调
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.ruleForm = {};
          this.flag = true;
          this.requestApi = true; //true新增,false修改
        })
        .catch((_) => {});
    },
    //编辑客户信息
    async goRedact(scope) {
      this.titleType = "修改商品信息";
      this.ruleForm = scope.row;
      //处理多余数据
      this.dialogFormVisible = true;
      this.requestApi = false;
      this.flag = true;
    },
    //删除单个
    deleteRow(row) {
      this.$confirm("确定删除吗?", "删除", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let R = await deleteGoods({ id: row.id });
          this.searchButton();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // // 全选
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    //分页
    currentChange(currentPage) {
      this.page = currentPage;
      this.searchButton();
    },
    sizeChange(limit) {
      this.page = 1; // 改每页条数：回到第 1 页
      this.limit = limit;
      this.searchButton();
    },
  },
};
</script>

<style lang="scss" scoped>
.handle_box {
  margin: 2vh 0;
}
</style>
